export default {
    DIRECT: 'direct',
    ZARINPAL: 'zarinpal',
    TRANSFER: 'transfer',
    BANK_RECEIPT: 'bank_receipt'
}